import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject;

import { Box } from '../../primitives/Box/Box.es.js';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import styled from 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
var NegativeWrapper = styled(Box).withConfig({
  componentId: "r1273b-0"
})(["", ";"], function (_ref) {
  var _ref$enableBelow = _ref.enableBelow,
      enableBelow = _ref$enableBelow === void 0 ? "md" : _ref$enableBelow,
      theme = _ref.theme;
  return theme.breakpoint(enableBelow, "down")(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n        margin-left: calc(var(--maestro-container-padding) * -1);\n        margin-right: calc(var(--maestro-container-padding) * -1);\n    "])));
});
export { NegativeWrapper };